var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlansBee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69.911,
    height: 69.896,
    viewBox: "0 0 69.911 69.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 49.602,
    height: 49.392,
    fill: "#fef587"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(33.05) rotate(42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3936",
    "data-name": "Path 3936",
    d: "M31.348,23.223a8.523,8.523,0,0,1-6.537,2.84,8.333,8.333,0,0,1-6.471-2.792,2.646,2.646,0,0,0-.381.8,56.825,56.825,0,0,1-5.035,10.387,11.2,11.2,0,0,1-5.864,4.776,7.583,7.583,0,0,1-3.745.412A3.841,3.841,0,0,1,.033,35.211a10.88,10.88,0,0,1,2.245-5.1A52.055,52.055,0,0,1,11.7,20.647q1.859-1.535,3.836-2.918a1.076,1.076,0,0,0,.514-.857,7.61,7.61,0,0,1,3.311-5.632c.356-.255.427-.417.177-.821A4.045,4.045,0,0,1,20.8,4.547a.622.622,0,0,0,.308-.785A2.532,2.532,0,0,0,18.6,1.528a12.648,12.648,0,0,0-1.823-.1,1.022,1.022,0,0,1-.667-.2.621.621,0,0,1-.253-.671.69.69,0,0,1,.571-.514,3.136,3.136,0,0,1,1.407.089,13.806,13.806,0,0,1,2.99,1.1A1.823,1.823,0,0,1,21.81,2.4c.107.356.236.706.342,1.062.087.292.244.361.531.251A6.228,6.228,0,0,1,27.005,3.7c.3.1.454.041.492-.267A3.211,3.211,0,0,1,30.1.675,14.38,14.38,0,0,1,32.39.044,3.243,3.243,0,0,1,33.1.016c.412.035.722.22.719.688a.688.688,0,0,1-.7.719c-.572.052-1.149.052-1.722.084a4.767,4.767,0,0,0-.653.086,2.5,2.5,0,0,0-2.261,2.434.268.268,0,0,0,.115.3c.084.057.169.112.252.17a4.144,4.144,0,0,1,1.24,5.977c-.2.326-.2.472.122.7a7.5,7.5,0,0,1,3.367,5.856c.027.4.289.549.542.73a78.314,78.314,0,0,1,8.721,7.277,34.778,34.778,0,0,1,4.8,5.49,10.114,10.114,0,0,1,1.944,4.839A3.832,3.832,0,0,1,45.8,39.7a9.655,9.655,0,0,1-7.323-3.045,21.334,21.334,0,0,1-3.854-5.869,72.749,72.749,0,0,1-3.046-7.022c-.065-.171-.141-.338-.228-.543",
    transform: "translate(0 0)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3937",
    "data-name": "Path 3937",
    d: "M342.643,779.893a23.644,23.644,0,0,1-8.979-1.656.92.92,0,0,1-.656-.789,8.892,8.892,0,0,1,.188-4.165c.115-.368.225-.381.545-.228a21.254,21.254,0,0,0,16.094.86,10.158,10.158,0,0,0,2.033-.911c.2-.115.279-.1.351.125a8.59,8.59,0,0,1,.112,4.706c-.073.3-.308.331-.518.413a23.993,23.993,0,0,1-9.17,1.644",
    transform: "translate(-317.905 -738.227)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3938",
    "data-name": "Path 3938",
    d: "M388.807,624.8a17.727,17.727,0,0,1-6.89-1.364c-.391-.164-.509-.3-.25-.71a15.381,15.381,0,0,0,1.368-2.714c.148-.385.314-.369.636-.241a14.59,14.59,0,0,0,11.265-.057c.255-.1.349-.067.444.182a14.229,14.229,0,0,0,1.531,3.025c.247.36-.045.388-.244.475a18.95,18.95,0,0,1-7.859,1.4",
    transform: "translate(-364.398 -591.84)",
    fill: "#fef587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3939",
    "data-name": "Path 3939",
    d: "M402.018,987.3a12.715,12.715,0,0,1-2.108,2.462,11.058,11.058,0,0,1-5.058,2.554,1.764,1.764,0,0,1-.8,0,10.948,10.948,0,0,1-6.987-4.836.531.531,0,0,1-.04-.138,21.618,21.618,0,0,0,14.993-.039",
    transform: "translate(-369.646 -942.966)",
    fill: "#fef587"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansBee);
export default __webpack_public_path__ + "static/media/plans-bee.906164018b310cb0dc90b4cf6410b1be.svg";
export { ForwardRef as ReactComponent };